'use client'

import * as React from 'react'
import * as RadixToggle from '@radix-ui/react-toggle'
import { VariantProps } from 'class-variance-authority'
import { mtc } from '../../../utils/style-helpers'
import { toggleVariants } from './styles'

export interface ToggleProps
  extends Omit<
      React.ComponentPropsWithoutRef<typeof RadixToggle.Root>,
      'pressed' | 'defaultPressed' | 'onPressedChange'
    >,
    VariantProps<typeof toggleVariants> {
  /** controlled checked state */
  checked?: boolean
  /** uncontrolled default checked state */
  defaultChecked?: boolean
  /** called when the pressed state changes */
  onCheckedChange?: (checked: boolean) => void
}

/** Displays a toggle or a toggle-like element */
export const Toggle: React.FC<ToggleProps> = ({
  className,
  variant,
  size,

  // controlled / uncontrolled props
  checked,
  defaultChecked,
  onCheckedChange,

  ...rest
}) => {
  return (
    <RadixToggle.Root
      className={mtc(toggleVariants({ variant, size }), className)}
      pressed={checked}
      defaultPressed={defaultChecked}
      onPressedChange={onCheckedChange}
      {...rest}
    />
  )
}

Toggle.displayName = 'Toggle'
